module.exports = __webpack_public_path__ + "img/9_diamond.951f7fd5.jpg";